import React from 'react';

const TradingPreferenceSelectors = (props) => {
  const MIN_STOCK_COUNT = 1;
  const MAX_STOCK_COUNT = 100;

  var {
    startDate,
    endDate,
    rebalanceFrequency,
    stockCount,
  } = props.data;

  let handleOnBlur = (type) => {
    switch(type) {
      case "startDate":
        if (startDate >= endDate) props.valueOnUpdate("startDate", endDate);
        return;
      case "endDate":
        if (startDate > endDate) props.valueOnUpdate("endDate", startDate);
        return;
      case "stockCount":
        if (stockCount < MIN_STOCK_COUNT) {
          props.valueOnUpdate("stockCount", MIN_STOCK_COUNT);
        } else if (stockCount > MAX_STOCK_COUNT) {
          props.valueOnUpdate("stockCount", MAX_STOCK_COUNT);
        }
        return;
      default:
        console.error("unknown `handleOnBlur` type");
    }
  }

  let timePeriodComponent = () =>
    <div className="tradingPreference">
      <p className="font-color-dark tradingPreferenceLabel">Start Date:</p>
      <div className="selectorStyle">
        <input
          className="font-color-dark tradingPreferenceInput"
          type="date"
          value={startDate}
          onChange={(e) => props.valueOnUpdate("startDate", e.target.value)}
          onBlur={() => handleOnBlur("startDate")}
        />
      </div>
      <p className="font-color-dark tradingPreferenceLabel">End Date:</p>
      <div className="selectorStyle">
        <input
          className="font-color-dark tradingPreferenceInput"
          type="date"
          value={endDate}
          onChange={(e) => props.valueOnUpdate("endDate", e.target.value)}
          onBlur={() => handleOnBlur("endDate")}
        />
      </div>
    </div>;
  let rebalanceFrequencyComponent = () =>
    <div className="tradingPreference">
      <p className="font-color-dark tradingPreferenceLabel">Rebalance Frequency:</p>
      <div className="selectorStyle">
        <label className="labelStyle" onClick={() => props.valueOnUpdate("rebalanceFrequency", "Monthly")}>
          <div className="radioContainer">
            <input
              type="radio"
              value="smallest"
              checked={rebalanceFrequency==='Monthly'}
            />
          </div>
          Monthly
        </label>
        <label className="labelStyle" onClick={() => props.valueOnUpdate("rebalanceFrequency", "Weekly")}>
          <div className="radioContainer">
            <input
              type="radio"
              value="largest"
              checked={rebalanceFrequency==='Weekly'}
            />
          </div>
          Weekly
        </label>
        <label className="labelStyle" onClick={() => props.valueOnUpdate("rebalanceFrequency", "Daily")}>
          <div className="radioContainer">
            <input
              type="radio"
              value="largest"
              checked={rebalanceFrequency==='Daily'}
            />
          </div>
          Daily
        </label>
      </div>
    </div>;
  let stockCountComponent = () =>
    <div className="tradingPreference">
      <p className="font-color-dark tradingPreferenceLabel">Stock Count:</p>
      <div className="selectorStyle">
        <input
          className="font-color-dark tradingPreferenceInput"
          type="number"
          value={stockCount}
          onChange={(e) => props.valueOnUpdate("stockCount", e.target.value)}
          onBlur={() => handleOnBlur("stockCount")}
        />
      </div>
    </div>;

  return (
    <div
      className="selectedCriteria padding-left-right-md border-top"
      onClick={() => props.clicked(null, 3)}
    >
      {timePeriodComponent()}
      {rebalanceFrequencyComponent()}
      {stockCountComponent()}
    </div>
  )
}

export default TradingPreferenceSelectors;



// WEBPACK FOOTER //
// ./src/views/PickerView/components/sidebar/TradingPreferenceSelectors.js